module.exports = __webpack_public_path__ + "img/mobile_btn6.013d8d04.png";